/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCalendarProps } from './type';

export const calendarDefaultProps: TdCalendarProps = {
  allowSameDay: false,
  autoClose: true,
  confirmBtn: '',
  firstDayOfWeek: 0,
  switchMode: 'none',
  type: 'single',
  usePopup: true,
  visible: false,
};
